import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { TableActionType as ta } from '@/util/enum';
import { DefaultListFeilds as df } from '../../types';
import { tooltipStyle, tooltip, cellWidth, ImgCell, FileCell } from '@/components/TableCell';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '协议编号',
            dataIndex: df.id,
            key: df.id,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '手机号码',
            dataIndex: df.tel,
            key: df.tel,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '姓名',
            dataIndex: df.name,
            key: df.name,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '身份证正反面',
            dataIndex: df.IDUrl,
            key: df.IDUrl,
            width: cellWidth.normal,
            align: 'center',
            render: (url, item) => (
                <div>
                    {ImgCell(url)}&nbsp;&nbsp;
                    {ImgCell(item[df.IDReverseUrl])}
                </div>
            )
        },
        {
            title: '委托书',
            dataIndex: df.proxyFileUrl,
            key: df.proxyFileUrl,
            width: cellWidth.normal,
            align: 'center',
            render: FileCell
        },
        {
            title: '申请时间',
            dataIndex: df.applyTime,
            key: df.applyTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '开通时间',
            dataIndex: df.openingTime,
            key: df.openingTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: df.stateDesc,
            key: df.stateDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (text, item) => this._renderActionCell(item[df.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail)}>详情</div>
            </div>
        );
    }


    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={df.id}
                    columns={this._takeColumns()}
                    rowSelection={rowSelection}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    rowSelection: PropTypes.object,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;